export const INTERCOM_ID = "vj56bv7k";
export const FULLSTORY_ID = "RCMHB";
export const SENTRY_ID = "https://fc60edf7cdf145509a184790e5fd549e@sentry.io/2029600";
